// Tryb — saved venues. Fill one in once, reuse it every season.

import { Badge, Button, Icon } from "../../ds/index.js";
import { Card, EmptyState } from "../../components/Card.jsx";
import { useStudio } from "../../lib/studioContext.js";

export default function Venues({ onStartVenue }) {
  const { venues } = useStudio();

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)", maxWidth: 560, lineHeight: 1.5 }}>
          Save a place once — address, photo of the door, parking, washrooms — and never type it again.
        </div>
        <Button variant="secondary" onClick={onStartVenue}>
          Add a venue
        </Button>
      </div>

      {!venues.length && <EmptyState style={{ padding: 48, borderRadius: "var(--radius-xl)" }}>Nowhere saved yet. Your first tryb adds one automatically.</EmptyState>}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
        {venues.map((v) => (
          <Card key={v.id} padding={0} style={{ overflow: "hidden" }}>
            <div
              style={{
                height: 110, background: "var(--navy-700)", color: "var(--sand-50)",
                display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.95,
              }}
            >
              <Icon name="Pin" size={64} sw={1.3} />
            </div>
            <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ fontFamily: "var(--font-display)", fontSize: "var(--text-md)", fontWeight: 800, letterSpacing: "var(--tracking-snug)" }}>
                {v.name}
              </div>
              <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-muted)" }}>
                {[v.hood, v.type].filter(Boolean).join(" · ").toUpperCase()}
              </div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 4 }}>
                {v.io && <Badge tone="neutral">{v.io}</Badge>}
                <Badge tone={v.entrance ? "success" : "warning"}>{v.entrance ? "Door photo added" : "No door photo yet"}</Badge>
              </div>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)", marginTop: 6 }}>
                {v.used ? `Used by ${v.used} ${v.used === 1 ? "tryb" : "trybs"}` : "Not used yet"}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
